import React, { Component } from 'react';
import { connect } from 'react-redux';
import Carousel from '../../home/carousels/Carousel';
import { getCategoryProducts } from '../../../redux/actions/product';
import {
  PRODUCTS_CATEGORY_RETRIEVED,
  PRODUCTS_CATEGORY_FAILED,
  PRODUCTS_CATEGORY_REQUESTED
} from '../../../redux/actions/types';
import ProductMiniature from '../../../commons/ProductMiniature';

class SubSubCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      loading: false
    };
  }

  componentDidMount() {
    this.props.getCategoryProducts(
      this.props.subSubCategory.map(c => c.id),
      'sub_sub_category'
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status !== this.props.status) {
      if (
        this.props.status === PRODUCTS_CATEGORY_REQUESTED &&
        this.props.products.currentCategory ===
          this.props.subSubCategory.map(c => c.id).join('-')
      ) {
        this.setState({ loading: true });
      }
      if (
        this.props.status === PRODUCTS_CATEGORY_RETRIEVED &&
        this.state.products.length === 0
      ) {
        this.setState({
          loading: false,
          products:
            this.props.products[
              this.props.subSubCategory.map(c => c.id).join('-')
            ] || []
        });
      }
      if (
        this.props.status === PRODUCTS_CATEGORY_FAILED &&
        this.props.products.currentCategory ===
          this.props.subSubCategory.map(c => c.id).join('-')
      ) {
        this.setState({ loading: false });
      }
    }
  }

  // TODO This isn't rendering, though its link should work :D
  render() {
    const { subSubCategory, productCarousel } = this.props;

    let categoryTreeLink = '';
    if (subSubCategory.length > 1) {
      categoryTreeLink = `/productos/${subSubCategory[0].sub_category.category.name.toLowerCase()}/${subSubCategory[0].sub_category.name.toLowerCase()}?${subSubCategory
        .map(c => `sub_sub_category=${c.id}`)
        .join('&')}`;
    } else {
      categoryTreeLink = `/productos/${subSubCategory[0].sub_category.category.name.toLowerCase()}/${subSubCategory[0].sub_category.name.toLowerCase()}/${subSubCategory[0].name.toLowerCase()}`;
    }
    let title = productCarousel
      ? `VER MÁS DE ${subSubCategory[0].name.toUpperCase()}`
      : `LO NUEVO DE ${subSubCategory
          .map(c => c.name.toUpperCase())
          .join(' y ')}`;

    return (
      <Carousel
        carouselHeader={title}
        carouselLink={categoryTreeLink}
        loading={this.state.loading}
      >
        {this.state.products.map(product => (
          <ProductMiniature key={product.id} product={product} />
        ))}
      </Carousel>
    );
  }
}

const mapStateToProps = state => ({
  status: state.product.status,
  products: state.product.categoryProducts,
  categories: state.categories.hashedCategories
});

const mapDispatchToProps = dispatch => ({
  getCategoryProducts: (categoryID, categoryType) =>
    dispatch(getCategoryProducts(categoryID, categoryType))
});

export default connect(mapStateToProps, mapDispatchToProps)(SubSubCategory);
